import React, { useState, useRef, useMemo } from 'react';
import { Button } from 'react-bootstrap';

import Table from 'components/common/Table';
import CreateUserModal from 'components/admin/user/CreateUserModal';

import { adminUserApi } from 'api';
import { useUserContext } from 'providers/UserProvider';

import {
  getAdminUserListColumns, // Import the new function
  ADMIN_USER_FILTER_OPTIONS,
} from 'constants/admin/user';

const User = () => {
  const tableRef = useRef();
  const [showCreateUserModal, setShowCreateUserModal] = useState(false);
  const { selectedTenant, selectedWarehouse } = useUserContext();

  const tenant = selectedTenant?.domains?.[0]?.domain;
  const warehouse = selectedWarehouse?.domain;

  const columns = useMemo(() => {
    return getAdminUserListColumns(tenant, warehouse);
  }, [tenant, warehouse]);

  const headerActions = (
    <Button
      variant="primary"
      size="sm"
      onClick={() => setShowCreateUserModal(true)}
    >
      Add User
    </Button>
  );

  const handleActionSuccess = () => {
    tableRef.current?.refetch();
  };

  return (
    <>
      <Table
        ref={tableRef}
        title="User"
        apiService={adminUserApi}
        sortable={true}
        columns={columns} // Use the memoized columns
        filterOptions={ADMIN_USER_FILTER_OPTIONS}
        headerActions={headerActions}
      />

      <CreateUserModal
        show={showCreateUserModal}
        onHide={() => setShowCreateUserModal(false)}
        onSuccess={handleActionSuccess}
      />
    </>
  );
};

export default User;
